export type ThemeTokenMap = Record<string, string>;

export const defaultThemeTokens: ThemeTokenMap = {
  'color.accent': 'oklch(0.73 0.22 42)',
  'color.accent-strong': 'oklch(0.66 0.24 36)',
  'color.bg': 'oklch(0.08 0.015 35)',
  'color.danger': 'oklch(0.62 0.2 25)',
  'color.ink': 'oklch(0.97 0.008 70)',
  'color.muted': 'oklch(0.72 0.02 70)',
  'color.panel': 'oklch(0.14 0.018 40)',
  'color.panel-strong': 'oklch(0.18 0.025 42)',
  'color.success': 'oklch(0.73 0.18 150)',
  'color.warning': 'oklch(0.77 0.16 72)',
  'radius.card': '12px',
  'radius.control': '12px',
};

const toCssVarName = (tokenName: string) => `--ig-${tokenName.replaceAll('.', '-')}`;

export const applyThemeTokens = (tokens: ThemeTokenMap) => {
  const root = document.documentElement;

  Object.entries(tokens).forEach(([key, value]) => {
    root.style.setProperty(toCssVarName(key), value);
  });
};
